export default "__VITE_ASSET__CcdHq0WI__"